import { IconButton, InputLabel, Tooltip, Typography } from '@material-ui/core';
import { StyledTableCell } from './tableStyle';
import './tcardTemplate.scss';
import moment from 'moment';
import { AppStorage } from '../../../../../Core/Service/storage-service';
import TodayIcon from '@material-ui/icons/Today';
import DialogComp from '../../../../../Core/Controls/Dialog/DialogComp';
import { TextBox } from '../../../../../Core/FormInput';
import TcardNotes from './addTcardNotes';
import NoteIcon from '@material-ui/icons/Note';
import { useState } from 'react';

export default function NotesRow(props) {
    const { calNotes, tCardCalendarID } = props;

    const [showNotes, setShowNotes] = useState(false);

    const closeNotes = () => {
        setShowNotes(false);
    };

    console.log(calNotes, 'calNotes');
    const portalSetting = AppStorage.getPortalSetting();

    return (
        <StyledTableCell className="holiday-container">
            <div className="holiday-container-header">
                <Typography className="holiday-container-lable">Notes </Typography>
                <Tooltip title="Notes" aria-label="UserHoliday">
                    <IconButton size="medium" className="holiday-container-icon-btn" onClick={() => setShowNotes(true)}>
                        <NoteIcon fontSize="small" className="holiday-container-icon" />
                    </IconButton>
                </Tooltip>
            </div>{' '}
            <div className={`holiday-container-list custom-scroll`}>
                <div
                    style={{
                        // background: k.bg,
                        // color: k.color,

                        borderBottom: `1px solid ${portalSetting.portalSettingsIsHolidayColor}`,
                        padding: 1
                        // background: 'red'
                    }}
                >
                    <Typography
                        style={
                            {
                                // color: portalSetting.portalSettingsIsHolidayColor
                            }
                        }
                        className="holiday-container-list-name"
                    >
                        {calNotes}
                    </Typography>
                </div>
            </div>
            {showNotes ? (
                <DialogComp title="Notes" onClose={closeNotes} maxWidth="md">
                    <TcardNotes tCardCalendarID={tCardCalendarID} note={calNotes} />
                </DialogComp>
            ) : null}
        </StyledTableCell>
    );
}
